import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { api } from '../../lib/api';
import { Button, Input, Card } from '../../components/ui/Kit';

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await api.auth.resetPasswordForEmail(email);
      setSent(true);
    } catch (err) {
      setError(err.message || 'Could not send reset email');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <Card className="max-w-md w-full p-8 shadow-xl border-0 ring-1 ring-gray-200">
        <div className="text-center mb-8">
          <div className="mx-auto h-12 w-12 bg-primary rounded-lg shadow-sm flex items-center justify-center mb-4">
            <span className="text-white font-bold text-2xl">P</span>
          </div>
          <h2 className="text-3xl font-bold text-gray-900">Reset your password</h2>
          <p className="mt-2 text-sm text-gray-600">
            Remember your password?{' '}
            <Link to="/login" className="font-medium text-primary hover:text-primary-dark">
              Sign in
            </Link>
          </p>
        </div>

        {sent ? (
          <div className="space-y-4">
            <div className="p-4 bg-green-50 text-green-800 text-sm rounded-md border border-green-100">
              If an account exists for that email, we sent a reset link. Check your inbox and spam folder,
              then open the link to choose a new password.
            </div>
            <Link
              to="/login"
              className="block text-center text-sm font-medium text-primary hover:text-primary-dark"
            >
              Back to sign in
            </Link>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="space-y-6">
            {error && (
              <div className="p-3 bg-red-50 text-red-500 text-sm rounded-md border border-red-100">{error}</div>
            )}

            <Input
              label="Email address"
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="agent@example.com"
            />

            <Button type="submit" className="w-full" isLoading={loading} size="lg">
              Submit
            </Button>
          </form>
        )}
      </Card>
    </div>
  );
}
